import { Button, Dialog, Icon, Intent } from "@blueprintjs/core"
import { MouseEvent, useEffect, useState, WheelEvent } from "react"
import { IState, useMainStore } from "src/settings/zustand"
import DialogRight from "./DialogRight"

export interface IGallertDialog {
    isOpen: boolean
    data: any[]
    i: number
    setI: (i:number) => void
    setIsOpen: (isOpen: boolean) => void

}
export const GalleryDialog = ({ isOpen, data, i, setI, setIsOpen }: IGallertDialog) : JSX.Element => { 
    const isGlleryFullSize = useMainStore((state: IState) => state.isGlleryFullSize) 
    const [isCloseShow, setIsCloseShow] = useState<boolean>(false)
    let time:any = ""
    useEffect(() => {
        time = setInterval(() => tick, 200)
        return () => clearInterval(time)
    }, [])
    
    const tick = () => {

    }
    const onClick = ( evt: MouseEvent<HTMLImageElement> ) => {
        var rect: DOMRect = evt.currentTarget.getBoundingClientRect()
        var x: number = evt.clientX - rect.left //x position within the element. 
        x / rect.width > .5 ? next() : prev()
    }
    const onWeel = ( evt: WheelEvent<HTMLImageElement> ) => {
        evt.deltaY > 0 ? next() : prev()
    }
    const onMove = ( evt: MouseEvent<HTMLImageElement> ) => {
        var rect: DOMRect = evt.currentTarget.getBoundingClientRect()
        var y: number = evt.clientY - rect.top //x position within the element. 
        setIsCloseShow( y / rect.height < .33)
    }
    const prev = () => {
        setI( i > 0 ? i-1 : data.length - 1 )
    }
    const next = () => {
        setI( i< data.length - 1 ? i + 1 : 0 )
    }
    return <>
        <Dialog
            lazy={ false } 
            isOpen={ isOpen } 
            portalClassName="overflow-hidden z-index-110"
            className="full flex-centered transparent flex-row"
        >
            <div className="prev ">
                <Button  
                    onClick={ prev } 
                    className="bg-dark-secondary hover-straght" 
                >
                    <Icon icon="chevron-left" size={ 33 } color="#FFFFFF" />
                </Button>
            </div>    
            <div className=" position-relative gallery-dialog">
                <img 
                    src={ Array.isArray( data ) && data[i] } 
                    alt=""  
                    className={ `gallery-dialog-thumbnail ${ isGlleryFullSize ? "full-size" : "" }` } 
                    onClick={onClick}
                    onWheel={onWeel}
                    onMouseMove={onMove}
                />
                <Button 
                    icon="cross" 
                    intent={Intent.DANGER} 
                    className={` ${isCloseShow ? "" : "d-none "} p-2 position-absolute top center m-2 rounded-circle `} 
                    style={{ left: "50%", transform: "translateX(-20px)"}}
                    onClick={() => setIsOpen(false)}
                />
            </div>
            <DialogRight 
                data={ data } 
                i={ i } 
                setI={ setI } 
                setIsOpen={ setIsOpen }
            />
        </Dialog>
    </>
} 

export default GalleryDialog